// Shared postcode-status heuristics + visual tokens for the AddNetworkRatecard UI.
// Mirror of admin/app/(main)/provider-rate-cards/postcodeStatus.ts — keep both files'
// heuristic in sync (the user-portal Copilot import and the admin provider-rate-cards
// import run against the same Anthropic prompt, so they hit the same edge cases).

export type PostcodeStatus = 'failed' | 'needsReview' | 'resolved'

// A prefix is "needs review" when the LLM emitted something so broad the user almost
// certainly wants to verify it against the source document. Single-character UK area
// codes ("S" → all of Sheffield, "M" → all of Manchester) are the canonical case —
// legitimate but covers thousands of streets, so usually a model misread of a wider
// table cell.
export function isNeedsReviewPrefix(prefix: string): boolean {
  return prefix.length === 1
}

// Visual tokens. Tailwind red/amber/blue 100 + 800. Spelled as hex because Glide Data Grid
// renders canvas cells with raw colours — themeOverride doesn't accept class names.
export const POSTCODE_STATUS_COLORS = {
  failed: { bg: '#FEE2E2', text: '#991B1B' },
  needsReview: { bg: '#FEF3C7', text: '#92400E' },
  resolved: { bg: '#EFF6FF', text: '#1E40AF' },
} as const

// Leading glyph for the location cell so the status is perceivable without colour
// (deuteranomaly / protanomaly users + anyone scanning with the page on grayscale).
// Glide cells are canvas, so we can't use aria — the glyph is the a11y signal.
export const POSTCODE_STATUS_GLYPHS = {
  failed: '✕',
  needsReview: '⚠',
} as const
